import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Pagination from '../pagination/Pagination';
import { Container } from 'react-bootstrap';
import { FaSearch, FaFilePdf } from 'react-icons/fa';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import './index.css'; // Reuses your premium styled-table variables


const AddressBook = () => {
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');



  // Metadata registers
const [metaData, setMetaData] = useState([]); // Holds raw unique pairings from clubMaster
const [regions, setRegions] = useState([]);
const [zones, setZones] = useState([]);
const [clubsList, setClubsList] = useState([]);

// Selection state parameters
const [selectedRegion, setSelectedRegion] = useState('');
const [selectedZone, setSelectedZone] = useState('');
const [selectedClub, setSelectedClub] = useState('');



const [cabinetDesignations, setCabinetDesignations] = useState([]);
const [selectedCabinetDesignation, setSelectedCabinetDesignation] = useState('');



  
  const [showPerPage] = useState(20);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage
  });

  const onChangePagination = (start, end) => {
    setPagination({ start, end });
  };

  // --- Fetch Core Directory Registry Dataset ---
  const fetchAddressData = async () => {
    try {
      setLoading(true);
      const dist = sessionStorage.getItem("dist");
      const res = await axios.post(`https://lionsdirectoryapi.emedha.in/member/api/member-region-data`, { dist });
      
      setMembers(res.data);
      setFilteredMembers(res.data);
    } catch (err) {
      console.error("Error fetching address details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddressData();
  }, []);


  useEffect(() => {
  const fetchFilterMeta = async () => {
    const dist = sessionStorage.getItem("dist");
    
    // Existing filter meta call
    const res = await axios.post('https://lionsdirectoryapi.emedha.in/member/api/api/filters/map', { dist });
    setMetaData(res.data);
    
    // NEW: Fetch cabinet designations
    try {
      const cabRes = await axios.post('https://lionsdirectoryapi.emedha.in/member/api/api/filters/cabinet-designations', { dist });
      setCabinetDesignations(cabRes.data);
    } catch (cabErr) {
      console.error("Error fetching cabinet designations:", cabErr);
    }
  };
  fetchFilterMeta();
}, []);


  // 1. Initial metadata loading pipeline
useEffect(() => {
  const fetchFilterMeta = async () => {
    const dist = sessionStorage.getItem("dist");
    const res = await axios.post('https://lionsdirectoryapi.emedha.in/member/api/api/filters/map', { dist });
    setMetaData(res.data);
    
    // Extract unique regions
    const uniqueRegions = [...new Set(res.data.map(item => item.regionChairperson).filter(Boolean))];
    setRegions(uniqueRegions);
  };
  fetchFilterMeta();
}, []);

// 2. Trigger fetch on any filter state modification
useEffect(() => {
  const fetchFilteredData = async () => {
    try {
      setLoading(true);
      const dist = sessionStorage.getItem("dist");
      const res = await axios.post(`https://lionsdirectoryapi.emedha.in/member/api/member-region-data`, {
        dist,
        region: selectedRegion,
        zone: selectedZone,
        clubName: selectedClub,
        cabinetDesignation: selectedCabinetDesignation
      });
      setMembers(res.data);
      setFilteredMembers(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  fetchFilteredData();
}, [selectedRegion, selectedZone, selectedClub, selectedCabinetDesignation]);

// 3. Dropdown relationship handler blocks
// 1. Compute dynamic lists down from active choices on every render
const availableRegions = [...new Set(metaData.map(d => d.regionChairperson).filter(Boolean))];

const availableZones = [...new Set(metaData
  .filter(d => (!selectedRegion || d.regionChairperson === selectedRegion))
  .map(d => d.zoneChairperson)
  .filter(Boolean)
)];

const availableClubs = [...new Set(metaData
  .filter(d => (!selectedRegion || d.regionChairperson === selectedRegion))
  .filter(d => (!selectedZone || d.zoneChairperson === selectedZone))
  .map(d => d.clubName)
  .filter(Boolean)
)];

// 2. Simple flat value triggers
const handleRegionChange = (e) => {
  const value = e.target.value;
  setSelectedRegion(value);
  
  // If the currently selected zone doesn't belong to this region, clear it out safely
  if (value && selectedZone) {
    const isValid = metaData.some(d => d.regionChairperson === value && d.zoneChairperson === selectedZone);
    if (!isValid) {
      setSelectedZone('');
      setSelectedClub('');
    }
  }
};

const handleZoneChange = (e) => {
  const value = e.target.value;
  setSelectedZone(value);

  // Auto-fill Region context if a zone is picked directly
  if (value && !selectedRegion) {
    const matched = metaData.find(d => d.zoneChairperson === value);
    if (matched) setSelectedRegion(matched.regionChairperson);
  }
};

const handleClubChange = (e) => {
  const value = e.target.value;
  setSelectedClub(value);

  // Auto-fill Region & Zone context if a club is picked directly
  if (value && (!selectedRegion || !selectedZone)) {
    const matched = metaData.find(d => d.clubName === value);
    if (matched) {
      if (!selectedRegion) setSelectedRegion(matched.regionChairperson);
      if (!selectedZone) setSelectedZone(matched.zoneChairperson);
    }
  }
};

  // --- Local Live Text Substring Filtering Handler ---
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    
    const filtered = members.filter(m => 
      (m.membershipNo && m.membershipNo.toString().toLowerCase().includes(value)) ||
      (m.membershipName && m.membershipName.toLowerCase().includes(value)) ||
      (m.clubs && m.clubs.toLowerCase().includes(value)) ||
      (m.address && m.address.toLowerCase().includes(value)) ||
      (m.mobile && m.mobile.toLowerCase().includes(value))
    );
    setFilteredMembers(filtered);
    setPagination({ start: 0, end: showPerPage }); // Reset pagination window on new searches
  };


// --- Export Shipping Postal Label Sheets to PDF ---
//   const downloadPostalLabelsPDF = () => {
//     const doc = new jsPDF('p', 'mm', 'a4');
//     const dist = sessionStorage.getItem("dist") ;
    
//     // Premium Branding Header Layout Configurations
//     doc.setFillColor(62, 49, 128); // Brand deep premium purple
//     doc.rect(0, 0, 210, 28, 'F');
    
//     doc.setTextColor(245, 214, 82); // Brand gold accent
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(20);
//     doc.text(`LIONS DISTRICT ${dist}`, 14, 12);
    
//     doc.setTextColor(255, 255, 255);
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(11);
//     doc.text("OFFICIAL COURIER & POSTAL SHIPPING LABELS REGISTER", 14, 20);

//     // ✅ Cleaned up: Formatting rows to only include fields needed for postal pasting
//     const labelRows = filteredMembers.map((m, idx) => [
//       idx + 1,
//       m.membershipName || '',
//       m.mobile || '',
//       m.address || ''
//     ]);

//     // Pass 'doc' instance directly into the autoTable function execution thread
//     autoTable(doc, {
//       startY: 34,
//       // ✅ Headers matching your exact requirements
//       head: [['S.No', 'Recipient Name', 'Contact Mobile', 'Complete Address']],
//       body: labelRows,
//       theme: 'grid',
//       headStyles: {
//         fillColor: [62, 49, 128],
//         textColor: [245, 214, 82],
//         fontSize: 11,
//         fontStyle: 'bold',
//         halign: 'left'
//       },
//       bodyStyles: {
//         fontSize: 10.5, // Slightly increased font size for easy physical reading on packets
//         textColor: [51, 51, 51],
//         lineColor: [180, 180, 180] // Darker borders to make cutting lines obvious
//       },
//       // ✅ Adjusted widths: Removed Membership No & Club Name, expanded Mobile to keep it on one line cleanly
//       columnStyles: {
//         0: { cellWidth: 20 },                     // S.No
//         1: { cellWidth: 55, fontStyle: 'bold' },   // Name given plenty of space
//         2: { cellWidth: 38, fontStyle: 'bold' },   // Expanded to 38mm to prevent mobile number from wrapping into two lines
//         3: { cellWidth: 'auto' }                  // Address automatically consumes all remaining space smoothly
//       },
//       styles: {
//         overflow: 'linebreak',
//         cellPadding: 5 // Extra padding making each block a clean, easily sliceable sticker label
//       },
//       margin: { left: 10, right: 10 }
//     });

//     doc.save(`Lions_Postal_Labels_Dist_${dist}.pdf`);
//   };


// const downloadPostalLabelsPDF = () => {
//     // A4 Dimensions: 210mm x 297mm
//     const doc = new jsPDF('p', 'mm', 'a4');
//     const dist = sessionStorage.getItem("dist") || "";
    
//     // Grid Setup Framework Rules
//     const cardsPerRow = 4;
//     const rowsPerPage = 6;
//     const cardsPerPage = cardsPerRow * rowsPerPage; // Exactly 24 cards per page
    
//     const pageMarginLeft = 10;
//     const pageMarginTop = 10;
    
//     // Pre-calculated Card Dimensions to fill A4 space cleanly
//     const cardWidth = 47.5; 
//     const cardHeight = 46.0; 
    
//     filteredMembers.forEach((member, index) => {
//       // Determine page index and current relative slot placement
//       const pageItemIndex = index % cardsPerPage;
      
//       // If we hit item 24, 48, 72, create a fresh page break instantly
//       if (index > 0 && pageItemIndex === 0) {
//         doc.addPage();
//       }
      
//       // Compute column (X) and row (Y) coordinate coordinates on current page
//       const col = pageItemIndex % cardsPerRow;
//       const row = Math.floor(pageItemIndex / cardsPerRow);
      
//       const x = pageMarginLeft + (col * cardWidth);
//       const y = pageMarginTop + (row * cardHeight);
      
//       // 1. Draw Card Sticker Outer Boundaries Cutting Guidelines
//       doc.setDrawColor(200, 200, 200); // Light gray cutting grid line
//       doc.setLineWidth(0.2);
//       doc.rect(x, y, cardWidth, cardHeight);
      
//       // 2. Render Card Recipient Name Label (Bold & Clear)
//       doc.setTextColor(62, 49, 128); // Premium Purple for Name Accent
//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(9); // Kept legible but safe from line-overflow clip
      
//       const nameText = member.membershipName || 'N/A';
//       // Truncate name if it exceeds card edge safety zone boundaries
//       const truncatedName = doc.splitTextToSize(nameText, cardWidth - 4);
//       doc.text(truncatedName[0], x + 3, y + 6);
      
//       // 3. Render Card Contact Mobile Metadata Row
//       doc.setTextColor(51, 51, 51);
//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(8);
//       doc.text(`Mo: ${member.mobile || 'N/A'}`, x + 3, y + 11);
      
//       // 4. Render Dynamic Multi-Line Complete Delivery Address Box
//       doc.setTextColor(100, 100, 100);
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(7.5);
      
//       const addressText = member.address || '';
//       // Automatically splits long text into sequential wrapping array nodes safely
//       const wrappedAddress = doc.splitTextToSize(addressText, cardWidth - 6);
      
//       // Print up to 5 lines of address details cleanly inside the label card height
//       let currentLineY = y + 16;
//       for (let i = 0; i < wrappedAddress.length; i++) {
//         if (currentLineY > (y + cardHeight - 3)) break; // Safety threshold stop
//         doc.text(wrappedAddress[i], x + 3, currentLineY);
//         currentLineY += 3.8; // Interline padding
//       }
//     });

//     doc.save(`Lions_Postal_Dist_${dist}.pdf`);
//   };

const downloadPostalLabelsPDF = () => {
  // A4 Dimensions: 210mm x 297mm
  const doc = new jsPDF('p', 'mm', 'a4');
  const dist = sessionStorage.getItem("dist") || "";
  
  // Grid Setup Framework Rules
  const cardsPerRow = 4;
  const rowsPerPage = 6;
  const cardsPerPage = cardsPerRow * rowsPerPage; // 24 cards per page
  
  const pageMarginLeft = 10;
  const pageMarginTop = 10;
  
  const cardWidth = 47.5; 
  const cardHeight = 46.0; 
  
  filteredMembers.forEach((member, index) => {
    const pageItemIndex = index % cardsPerPage;
    
    if (index > 0 && pageItemIndex === 0) {
      doc.addPage();
    }
    
    const col = pageItemIndex % cardsPerRow;
    const row = Math.floor(pageItemIndex / cardsPerRow);
    
    const x = pageMarginLeft + (col * cardWidth);
    const y = pageMarginTop + (row * cardHeight);
    
    // 1. Draw Card Sticker Boundaries
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.2);
    doc.rect(x, y, cardWidth, cardHeight);
    
    // 2. Render Name (1 line cleanly truncated)
    doc.setTextColor(62, 49, 128);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    const nameText = (member.membershipName || 'N/A').replace(/\s+/g, ' ').trim();
    const truncatedName = doc.splitTextToSize(nameText, cardWidth - 6);
    doc.text(truncatedName[0], x + 3, y + 6);
    
    // 3. Render Mobile
    doc.setTextColor(51, 51, 51);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.text(`Mo: ${member.mobile || 'N/A'}`, x + 3, y + 10.5);
    
    // 4. Sanitize & Normalize Address String
    doc.setTextColor(90, 90, 90);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);

    // Replace newlines/tabs with comma+space and collapse multiple spaces
    const cleanAddress = (member.address || '')
      .replace(/[\r\n\t]+/g, ', ')
      .replace(/\s*,\s*/g, ', ')
      .replace(/\s+/g, ' ')
      .replace(/^,\s*|,\s*$/g, '')
      .trim();

    // Wrap clean single-string address to text box width
    const wrappedAddress = doc.splitTextToSize(cleanAddress, cardWidth - 6);
    
    // Render lines with comfortable spacing (3.2mm line-height for 7pt font)
    let currentLineY = y + 15;
    const maxY = y + cardHeight - 3;

    for (let i = 0; i < wrappedAddress.length; i++) {
      if (currentLineY > maxY) break;
      doc.text(wrappedAddress[i], x + 3, currentLineY);
      currentLineY += 3.2; 
    }
  });

  doc.save(`Lions_Postal_Dist_${dist}.pdf`);
};

  return (

  <div className="main-address-book-wrapper p-4 bg-light-subtle min-vh-100">
    
    {/* Row 1: Premium Dashboard Dropdown Filters Matrix View */}
    {/* <div className="row g-3 mb-4 p-3 rounded-4 bg-white shadow-sm border border-light-subtle">
      <div className="col-12 col-md-3">
        <label className="fw-bold mb-1 text-secondary" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>REGION FILTER</label>
        <select className="form-select bg-light border-0 py-2" value={selectedRegion} onChange={handleRegionChange} style={{ borderRadius: "8px", fontWeight: "500" }}>
          <option value="">-- All Regions --</option>
          {availableRegions.map((r, i) => <option key={i} value={r}>{r}</option>)}
        </select>
      </div>

      <div className="col-12 col-md-3">
        <label className="fw-bold mb-1 text-secondary" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>ZONE FILTER</label>
        <select className="form-select bg-light border-0 py-2" value={selectedZone} onChange={handleZoneChange} style={{ borderRadius: "8px", fontWeight: "500" }}>
          <option value="">-- All Zones --</option>
          {availableZones.map((z, i) => <option key={i} value={z}>{z}</option>)}
        </select>
      </div>

<div className="col-12 col-md-4">
        <label className="fw-bold mb-1 text-secondary" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>CLUB NAME FILTER</label>
        <select className="form-select bg-light border-0 py-2" value={selectedClub} onChange={handleClubChange} style={{ borderRadius: "8px", fontWeight: "500" }}>
          <option value="">-- All Clubs --</option>
      
          {[...availableClubs].sort((a, b) => a.localeCompare(b)).map((c, i) => (
            <option key={i} value={c}>{c}</option>
          ))}
        </select>
      </div>

      {(selectedRegion || selectedZone || selectedClub) && (
        <div className="col-12 col-md-2 d-flex align-items-end ">
          <button className="btn btn-outline-danger w-100 py-2" onClick={() => { setSelectedRegion(''); setSelectedZone(''); setSelectedClub(''); }} style={{ borderRadius: "8px", fontWeight: "600", fontSize: "13px" }}>
            Clear Matrix
          </button>
        </div>
      )}
    </div> */}

    {/* Dropdown Filters Matrix View */}
<div className="row g-3 mb-4 p-3 rounded-4 bg-white shadow-sm border border-light-subtle">
  <div className="col-12 col-md-3">
    <label className="fw-bold mb-1 text-secondary" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>REGION FILTER</label>
    <select className="form-select bg-light border-0 py-2" value={selectedRegion} onChange={handleRegionChange} style={{ borderRadius: "8px", fontWeight: "500" }}>
      <option value="">-- All Regions --</option>
      {availableRegions.map((r, i) => <option key={i} value={r}>{r}</option>)}
    </select>
  </div>

  <div className="col-12 col-md-3">
    <label className="fw-bold mb-1 text-secondary" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>ZONE FILTER</label>
    <select className="form-select bg-light border-0 py-2" value={selectedZone} onChange={handleZoneChange} style={{ borderRadius: "8px", fontWeight: "500" }}>
      <option value="">-- All Zones --</option>
      {availableZones.map((z, i) => <option key={i} value={z}>{z}</option>)}
    </select>
  </div>

  <div className="col-12 col-md-3">
    <label className="fw-bold mb-1 text-secondary" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>CLUB NAME FILTER</label>
    <select className="form-select bg-light border-0 py-2" value={selectedClub} onChange={handleClubChange} style={{ borderRadius: "8px", fontWeight: "500" }}>
      <option value="">-- All Clubs --</option>
      {[...availableClubs].sort((a, b) => a.localeCompare(b)).map((c, i) => (
        <option key={i} value={c}>{c}</option>
      ))}
    </select>
  </div>

  {/* NEW: Cabinet Designation Filter */}
  <div className="col-12 col-md-3">
    <label className="fw-bold mb-1 text-secondary" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>CABINET DESIGNATION</label>
    <select 
      className="form-select bg-light border-0 py-2" 
      value={selectedCabinetDesignation} 
      onChange={(e) => setSelectedCabinetDesignation(e.target.value)} 
      style={{ borderRadius: "8px", fontWeight: "500" }}
    >
      <option value="">-- All Designations --</option>
      {cabinetDesignations.map((desig, i) => (
        <option key={i} value={desig}>{desig}</option>
      ))}
    </select>
  </div>

  {/* Clear Matrix Button */}
  {(selectedRegion || selectedZone || selectedClub || selectedCabinetDesignation) && (
    <div className="col-12 d-flex justify-content-end mt-2">
      <button 
        className="btn btn-outline-danger px-4 py-2" 
        onClick={() => { 
          setSelectedRegion(''); 
          setSelectedZone(''); 
          setSelectedClub(''); 
          setSelectedCabinetDesignation('');
        }} 
        style={{ borderRadius: "8px", fontWeight: "600", fontSize: "13px" }}
      >
        Clear Matrix
      </button>
    </div>
  )}
</div>

    {/* Row 2: Secondary Controls Row (Search and Export Alignment) */}
    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
      <div className="search-box-container position-relative flex-grow-1" style={{ maxWidth: "400px" }}>
        <FaSearch className="position-absolute text-muted" style={{ left: "15px", top: "13px", zIndex: 10 }} />
        <input 
          type="search" 
          className="form-control ps-5 py-2 shadow-sm border-0" 
          placeholder="Search name, club, or address..." 
          value={search}
          onChange={handleSearch}
          style={{ borderRadius: "10px", height: "42px" }}
        />
      </div>

      <button 
        className="btn text-white d-flex align-items-center gap-2 px-4 shadow-sm"
        onClick={downloadPostalLabelsPDF}
        disabled={filteredMembers.length === 0}
        style={{ backgroundColor: "#3e3180", borderRadius: "10px", fontWeight: "600", height: "42px" }}
      >
        <FaFilePdf size={16} style={{ color: "#F5D652" }} />
        Export Delivery Labels PDF
      </button>
    </div>

      {/* Main Grid View Display Table */}
      <div className="table-container shadow-sm rounded-4 overflow-hidden bg-white">
        <table className="styled-table table table-striped table-hover table-bordered mb-0">
          <thead>
            <tr style={{ backgroundColor: "#3e3180", color: "#fff" }}>
              <th className="py-3" style={{ width: "60px" }}>S.No</th>
              <th className="py-3">Membership No</th>
              <th className="py-3">Membership Name</th>
              <th className="py-3">Club Name</th>
              <th className="py-3">Mobile</th>
              <th className="py-3">Postal Address</th>
            </tr>
          </thead>
          <tbody>
            {filteredMembers.slice(pagination.start, pagination.end).map((data, index) => (
              <tr key={data.memberId || index}>
                <td className="align-middle text-center">{pagination.start + index + 1}</td>
                <td className="align-middle fw-semibold text-secondary">{data.membershipNo}</td>
                <td className="align-middle text-dark fw-bold">{data.membershipName}</td>
                <td className="align-middle">{data.clubs}</td>
                <td className="align-middle fw-bold text-primary">{data.mobile}</td>
                <td className="align-middle text-muted lh-base" style={{ fontSize: "13px", maxWidth: "400px" }}>
                  {data.address}
                </td>
              </tr>
            ))}
            {filteredMembers.length === 0 && !loading && (
              <tr>
                <td colSpan="6" className="text-center text-muted py-5">
                  No matching recipient address records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        
        <Pagination 
          page={showPerPage} 
          onChangePagination={onChangePagination} 
          total={filteredMembers.length} 
        />
      </div>
    </div>
  );
};

export default AddressBook;